export const DJ_SETUP_CATEGORY = 'DJ Equipment/Bundle'

export const DJ_COMPONENT_CATEGORIES = [
  'DJ Equipment/CDJs',
  'DJ Equipment/Mixers',
  'DJ Equipment/Controller',
  'DJ Equipment/Turntables',
  'DJ Equipment/Booth',
  'DJ Equipment/Effects'
]

export const DJ_UTILITY_CATEGORIES = [
  'DJ Equipment/Cables',
  'DJ Equipment/Interface',
  'DJ Equipment/Interfaces',
  'DJ Equipment/Microphones'
]

const includesCategory = (product, category) => product?.categories?.includes(category)

export const isSouthFloridaDjRental = product => Boolean(
  product
  && !product.only_orlando
  && !product.only_purchase
  && (!product.status || product.status === 'active')
)

export const isDjSetupProduct = product => (
  isSouthFloridaDjRental(product) && includesCategory(product, DJ_SETUP_CATEGORY)
)

export const isDjComponentProduct = product => (
  isSouthFloridaDjRental(product)
  && !includesCategory(product, DJ_SETUP_CATEGORY)
  && DJ_COMPONENT_CATEGORIES.some(category => includesCategory(product, category))
)

export const sanitizeDjCatalogProduct = product => ({
  ...product,
  snippets: (product?.snippets || []).filter(snippet => {
    const normalized = String(snippet || '').trim().toLowerCase()
    return normalized !== 'wattage//0w' && normalized !== 'event size//0 people'
  })
})

export const getDjSetupProducts = products => (
  (products || []).filter(isDjSetupProduct).map(sanitizeDjCatalogProduct)
)

export const getDjComponentProducts = products => (
  (products || []).filter(isDjComponentProduct).map(sanitizeDjCatalogProduct)
)
